module.exports = {
      id: "android-small-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#android-small",
      toString: function () {
        return this.url;
      }
    }